import React from "react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useEmailLogs } from "../hooks";
import { formatDisplayDate } from "../../../helpers/date";

interface IProps {
  orderId: number;
}

export const EmailLogsList: React.FC<IProps> = ({ orderId }) => {
  const { data, loading } = useEmailLogs({ where: { orderId } });

  if (loading) return <Loading />;

  if (!data?.emailLogs?.results?.length) {
    return <EmptyList text="Aucun email envoyé" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Destinataire</TableCell>
          <TableCell header>Statut</TableCell>
          <TableCell header>Envoyé le</TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.emailLogs?.results?.map((log) => (
          <TableRow key={`email-log-${log.id}`} hover={false}>
            <TableCell>{log.recipient}</TableCell>
            <TableCell>{log.status}</TableCell>
            <TableCell>{formatDisplayDate(log.sentAt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
